import { SelectOption } from 'components/shared/Select'
import { OnSelectCallbackParam } from 'react-daterange-picker'
import { PaginationProps, SortDirection } from 'utilities'

export enum FilterPeriods {
  TODAY = 'Today',
  PAST_WEEK = 'Past week',
  PAST_MONTH = 'Past month',
  PAST_3_MONTHS = 'Past 3 months',
  CUSTOM = 'Custom'
}

export const periodOptions: SelectOption<FilterPeriods>[] = Object.values(FilterPeriods)
  .map(period => ({
    value: period,
    label: period
  }))

export enum ActionHistoryTableSortProps {
  PERIOD = 'createdOn',
  ACTION_TYPE = 'action',
  ENTITY_TITLE = 'entityTitle',
  CHANGES = 'changes'
}

export type ActionHistoryTableSearchProps = {
  period: OnSelectCallbackParam
  action: string
  title: string
  changes: string
}

export type ActionHistoryFilterDTO = {
  startDate: number
  endDate: number
  action: string
  userId: string
  title: string
  changes: string
}

export const initialActionHistoryTableSearchProps: ActionHistoryTableSearchProps = {
  period: null,
  action: '',
  title: '',
  changes: ''
}

export const initialActionHistoryPaginationProps: PaginationProps<
  ActionHistoryTableSortProps
> = {
  page: 0,
  size: 15,
  sortDirection: SortDirection.DESC,
  sortProp: ActionHistoryTableSortProps.PERIOD,
  totalElements: 0,
  totalPages: 0
}

export const actionHistoryTableNeedTimeoutProps: Array<
  keyof ActionHistoryTableSearchProps
> = ['title', 'changes']
